module.exports = __webpack_public_path__ + "static/media/agenda.5280ea97.svg";